


































































































































































































































































import { Component } from 'vue-property-decorator'
import VueBase from '@/VueBase'
import { ScaListObj, ScaObj, VulObj } from '@/views/sca/types'

@Component({ name: 'ScaDetail' })
export default class ScaDetail extends VueBase {
  private sliderWarpContract = false
  private scaObj = {}
  private tableData: Array<ScaListObj> = []
  private page = 1
  private selectedId = 0
  private total = 0
  private vulDetailDialogShow = false
  private vulDetail: VulObj | undefined
  private searchObj = {
    language: '',
    level: '',
    project_name: '',
    keyword: '',
    order: '',
  }

  private orderOptions = [
    {
      label: this.$t('views.scaList.orderOptions.project_name'),
      value: 'project_name',
    },
    {
      label: this.$t('views.scaList.orderOptions.level'),
      value: 'level',
    },
    {
      label: this.$t('views.scaList.orderOptions.package_name'),
      value: 'package_name',
    },
    {
      label: this.$t('views.scaList.orderOptions.version'),
      value: 'version',
    },
    {
      label: this.$t('views.scaList.orderOptions.language'),
      value: 'language',
    },
    {
      label: this.$t('views.scaList.orderOptions.vul_count'),
      value: 'vul_count',
    },
  ]

  async created() {
    this.page = parseInt(this.$route.params.page)
    this.selectedId = parseInt(this.$route.params.id)
    await this.getScaDetail()
    await this.getTableData()
  }

  private newSelectData() {
    this.page = 1
    this.getTableData()
  }

  private currentChange(val: number) {
    this.page = val
    this.getTableData()
  }

  private async getTableData() {
    const params = {
      page: this.page,
      pageSize: 10,
      language: this.searchObj.language,
      level: this.searchObj.level,
      project_name: this.searchObj.project_name,
      keyword: this.searchObj.keyword,
      order: this.searchObj.order,
    }
    this.loadingStart()
    const { status, data, page, msg } = await this.services.sca.scaList(params)
    this.loadingDone()
    if (status !== 201) {
      this.$message({
        type: 'error',
        message: msg,
        showClose: true,
      })
      return
    }
    this.tableData = data
    this.total = page.alltotal
  }

  private idChange(id: number) {
    this.selectedId = id
    this.getScaDetail()
  }

  private async getScaDetail() {
    this.loadingStart()
    const { data, status, msg } = await this.services.sca.getScaDetail(
      this.selectedId
    )
    this.loadingDone()
    if (status !== 201) {
      this.$message({
        type: 'error',
        message: msg,
        showClose: true,
      })
      return
    }
    this.scaObj = data
  }

  private detailShow(row: any) {
    this.vulDetail = row
    this.vulDetailDialogShow = true
  }
}
